import axios, { AxiosInstance } from 'axios';
import { useAuthStore } from '../../store';
import { storageUtil } from '../../utils/storage.util';
import { IUserIpLocation } from '../../models/resource.model';
import { handleTokenRefresh } from './tokenRefreshHandler';

const createAxiosInstance = (
  baseURL: string = 'https://api-gateway-dev.rynopay.io/api/',
  timeout: number = 60000
): AxiosInstance => {
  const axiosInstance = axios.create({
    baseURL,
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
    },
    timeout,
  });

  axiosInstance.interceptors.request.use((config) => {
    const userIpLocation: IUserIpLocation | null = storageUtil.getItem(
      'user-ip-location',
      'local',
    );
    const { getAccessToken } = useAuthStore.getState();
    const accessToken = getAccessToken();

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    if (userIpLocation) {
      config.headers['X-User-IP'] = userIpLocation.ipAddress;
      config.headers['X-User-City'] = userIpLocation.city;
      config.headers['X-User-State'] = userIpLocation.state;
      config.headers['X-User-Country'] = userIpLocation.countryName;
      config.headers['X-User-Agent'] = userIpLocation.userAgent;
      config.headers['X-Device-Type'] = userIpLocation.deviceType;
      config.headers['X-User-Platform'] = userIpLocation.platform;
    }

    return config;
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      return handleTokenRefresh(error, axiosInstance, timeout);
    },
  );

  return axiosInstance;
};

export default createAxiosInstance;
